export default __webpack_public_path__ + "static/media/43.fe0ac925.png";